import CommonErrorPage from "./Common/CommonErrorPage";

const Error403 = () => {
  return <CommonErrorPage color="success" page="403" />;
};

export default Error403;
